<div class="card">
  <div class="card-header">Referral Rewards</div>
  <div class="card-block">
    <h3 class="text-center">Referee Rewards</h3>
    <div class="table-responsive">
      <div class="loading-cont" *ngIf="loading">
        <div class="loading-spinner"></div>
      </div>
      <table class="table table-hover" *ngIf="!loading">
        <thead>
          <tr>
            <th>
              <span class="col-name">Coupon</span>
            </th>
            <th>
              <span class="col-name">Created At</span>
            </th>
            <th>Actions</th>
          </tr>
        </thead>
        <tbody>
          <tr *ngIf="refereeRewards.length === 0; else hasRefereeRewards">
            <td colspan="3" class="text-center">
              <a id="referralRewardsListRefereeNew" [routerLink]="['/admin/referral-rewards/edit']" [queryParams]="{
                  referralProgramId: this.referralProgramId,
                  target: 'REFEREE'
                }" class="btn btn-default">
                Add
              </a>
            </td>
          </tr>
          <ng-template #hasRefereeRewards>
            <tr *ngIf="activeRefereeReward">
              <td>
                <code>{{ couponName(activeRefereeReward.couponId) }}</code>
              </td>
              <td>
                <span>{{ activeRefereeReward.createdAt | dateFormat }}</span>
              </td>
              <td class="col-md-2">
                <a class="btn btn-primary" (click)="edit(activeRefereeReward)">
                  Edit
                </a>
                <a class="btn btn-danger btn-right" (click)="delete(activeRefereeReward)">
                  Delete
                </a>
              </td>
            </tr>
            <tr *ngIf="nonActiveRefereeRewards.length > 0">
              <td colspan="7" class="text-center">
                <button class="btn btn-secondary" (click)="togglePreviousRefereeRewards()">
                  {{ showPreviousRefereeRewards ? "Hide" : "Show" }} Previous
                  Referee Rewards
                </button>
              </td>
            </tr>
            <ng-container *ngIf="showPreviousRefereeRewards">
              <tr *ngFor="let item of nonActiveRefereeRewards; let i = index" class="active">
                <td>
                  <code>{{ couponName(item.couponId) }}</code>
                </td>
                <td>
                  <span>{{ item.createdAt | dateFormat }}</span>
                </td>
                <td class="col-md-2">
                  <a class="btn btn-danger btn-right" (click)="delete(item)">
                    Delete
                  </a>
                </td>
              </tr>
            </ng-container>
          </ng-template>
        </tbody>
      </table>
    </div>
    <div class="table-responsive">
      <h3 class="text-center">Referrer Rewards</h3>
      <div class="loading-cont" *ngIf="loading">
        <div class="loading-spinner"></div>
      </div>
      <table class="table table-hover" *ngIf="!loading">
        <thead>
          <tr>
            <th>
              <span class="col-name">Coupon</span>
            </th>
            <th>
              <span class="col-name">Type</span>
            </th>
            <th>
              <span class="col-name">Referrals Count</span>
            </th>
            <th>
              <span class="col-name">Max Redemptions</span>
            </th>
            <th>
              <span class="col-name">Auto Redeem</span>
            </th>
            <th>
              <span class="col-name">Created At</span>
            </th>
            <th>Actions</th>
          </tr>
        </thead>
        <tbody>
          <tr *ngIf="referrerRewards.length === 0; else hasReferrerRewards">
            <td colspan="7" class="text-center">
              <a id="referralRewardsListReferrerNew" [routerLink]="['/admin/referral-rewards/edit']" [queryParams]="{
                  referralProgramId: this.referralProgramId,
                  target: 'REFERRER'
                }" class="btn btn-default">
                Add
              </a>
            </td>
          </tr>
          <ng-template #hasReferrerRewards>
            <tr *ngIf="activeReferrerReward">
              <td>
                <code>{{ couponName(activeReferrerReward.couponId) }}</code>
              </td>
              <td>
                <span>{{ activeReferrerReward.type }}</span>
              </td>
              <td>
                <span>{{ activeReferrerReward.referralsCount }}</span>
              </td>
              <td>
                <span>{{ activeReferrerReward.maxRedemptionsPerMember }}</span>
              </td>
              <td>
                <input type="checkbox" [checked]="activeReferrerReward.autoRedeem" onclick="return false;" />
              </td>
              <td>
                <span>{{ activeReferrerReward.createdAt | dateFormat }}</span>
              </td>
              <td class="col-md-2">
                <a class="btn btn-primary" (click)="edit(activeReferrerReward)">
                  Edit
                </a>
                <a class="btn btn-danger btn-right" (click)="delete(activeReferrerReward)">
                  Delete
                </a>
              </td>
            </tr>
            <tr *ngIf="nonActiveReferrerRewards.length > 0">
              <td colspan="7" class="text-center">
                <button class="btn btn-secondary" (click)="togglePreviousReferrerRewards()">
                  {{ showPreviousReferrerRewards ? "Hide" : "Show" }} Previous
                  Referrer Rewards
                </button>
              </td>
            </tr>
            <ng-container *ngIf="showPreviousReferrerRewards">
              <tr *ngFor="let item of nonActiveReferrerRewards; let i = index" class="active">
                <td>
                  <code>{{ couponName(item.couponId) }}</code>
                </td>
                <td>
                  <span>{{ item.type }}</span>
                </td>
                <td>
                  <span>{{ item.referralsCount }}</span>
                </td>
                <td>
                  <span>{{ item.maxRedemptionsPerMember }}</span>
                </td>
                <td>
                  <input type="checkbox" [checked]="item.autoRedeem" onclick="return false;" />
                </td>
                <td>
                  <span>{{ item.createdAt | dateFormat }}</span>
                </td>
                <td class="col-md-2">
                  <a class="btn btn-danger btn-right" (click)="delete(item)">
                    Delete
                  </a>
                </td>
              </tr>
            </ng-container>
          </ng-template>
        </tbody>
      </table>
    </div>
  </div>
</div>



// WEBPACK FOOTER //
// /Users/thxgg/Projects/Work/code-hospitality-cms/src/app/referrals/rewards/rewards-list.component.html